import React from 'react';

import './ConfirmAlert.scss';

interface ConfirmAlertProps {
  title: string;
  onClose: any;
  children?: any;
}
const theme = document.body.classList.contains("dark") ? "light" : "dark";

export function ConfirmAlert(props: ConfirmAlertProps) {
  const childrenItems = React.Children.map(props.children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child);
    }

    return child;
  });

  return (
    <div className={`confirm-alert-${theme}`}>
      <div className="confirm-header">
        <h1>{props.title}</h1>
        <span onClick={props.onClose} className="close">
          &times;
        </span>
      </div>
      <div className="confirm-body">{childrenItems}</div>
    </div>
  );
}
